import { LoadingContainer } from 'components/loadingContainer'
import { Spinner } from 'components/loadingContainer/LoadingContainer.styled'
import { PlaceholderContainer } from 'components/placeholder'
import { useSelectedEventForScan } from 'context/SelectedEventForScan'
import { TicketScan } from 'features/admin/Ticket'
import { useEventByIdAdmin } from 'hooks/admin/useEvents/useEventById'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const TicketScanPage = () => {
    const { selectedEventId } = useSelectedEventForScan()
    const navigate = useNavigate()

    const { data, isLoading, error, refetch } = useEventByIdAdmin(selectedEventId || '')

    useEffect(() => {
        if (!selectedEventId) {
            navigate('/admin/jegyellenorzes/esemenyvalasztas', { replace: true })
        }
    }, [selectedEventId, navigate])

    if (!selectedEventId || isLoading || !data) return <Spinner />
    if (error)
        return (
            <PlaceholderContainer>
                <p>Jelenleg nincs esemény, amely megfelel a feltételeknek.</p>
            </PlaceholderContainer>
        )

    return (
        <LoadingContainer isLoading={isLoading} error={error}>
            <meta name="robots" content="noindex, nofollow" />
            <TicketScan event={data} refetch={refetch} />
        </LoadingContainer>
    )
}
